module.exports = __webpack_public_path__ + "static/media/good-v2.dc6dd69a.svg";